import React from 'react';
// import { CellContext } from '@tanstack/react-table';
import { DeviceOperationsColumnConfig } from '@/types/table.types';
// import { OperationResponse } from '@/types/operation.types';
import {
  DeviceOperationsOperationIdCell,
  DeviceOperationsDateCell,
  DeviceOperationsDurationCell,
  DeviceOperationsCentroidLocationCell,
  DeviceOperationsTimezoneCell,
} from '@/components/features/operations/deviceOperationsTableCells';
// import { DeviceOperationsCoordinatesCell } from '@/components/features/operations/deviceOperationsTableCells/DeviceOperationsCoordinatesCell';

// Funciones de filtrado personalizadas para diferentes tipos de datos
const filterNumericOptions = (options: string[], searchTerm: string): string[] => {
  if (!searchTerm.trim()) return options;

  const searchNum = parseFloat(searchTerm);
  if (isNaN(searchNum)) {
    // Si no es un número válido, buscar coincidencias exactas en el texto
    return options.filter((opt) => opt.includes(searchTerm));
  }

  // Filtrar por valor numérico
  return options.filter((opt) => {
    const optNum = parseFloat(opt);
    return !isNaN(optNum) && optNum === searchNum;
  });
};

const filterCoordinateOptions = (options: string[], searchTerm: string): string[] => {
  if (!searchTerm.trim()) return options;

  // Buscar coordenadas que contengan el término de búsqueda
  // Las coordenadas pueden estar en formato "lat, lng" o "lat,lng"
  const normalizedSearch = searchTerm.replace(/\s+/g, '').toLowerCase();

  return options.filter((opt) => {
    const normalizedOpt = opt.replace(/\s+/g, '').toLowerCase();
    return normalizedOpt.includes(normalizedSearch);
  });
};

/*
const filterTextOptions = (options: string[], searchTerm: string): string[] => {
  if (!searchTerm.trim()) return options;

  return options.filter((opt) => opt.toLowerCase().includes(searchTerm.toLowerCase()));
};
*/

export const getDeviceOperationsTableColumns = (): DeviceOperationsColumnConfig[] => [
  {
    id: 'id',
    accessor: 'id',
    header: 'pages.operations.columns.operationId',
    enableSorting: true,
    enableFilter: true,
    filterType: 'text',
    cell: ({ getValue, row }) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <DeviceOperationsOperationIdCell info={{ getValue, row } as any} />
    ),
  },
  {
    id: 'lectureCount',
    accessor: 'lectureCount',
    header: 'pages.operations.columns.lectureCount',
    enableSorting: true,
    enableFilter: true,
    filterType: 'number',
    filterOptions: filterNumericOptions,
    getOptionLabel: (option: string) => option.toString(),
  },
  // Centroid Location - Coordinates
  // Centroid Location - Latitud
  {
    id: 'centroidLocation',
    accessor: 'centroidLocation',
    header: 'pages.operations.columns.centroidLocation',
    enableSorting: false,
    enableFilter: false,
    filterType: 'text',
    filterOptions: filterCoordinateOptions,
    cell: ({ getValue, row }) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <DeviceOperationsCentroidLocationCell info={{ getValue, row } as any} />
    ),
  },
  /*
  {
    id: 'centroid_latitutde',
    accessor: 'centroid_latitutde',
    header: 'pages.operations.columns.centroid_latitutde',
    enableSorting: false,
    enableFilter: false,
    filterType: 'text',
    filterOptions: filterCoordinateOptions,
    cell: ({ getValue, row }) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <DeviceOperationsCoordinatesCell info={{ getValue, row } as any} coordinateType="latitude" />
    ),
  },
  */
  // Centroid Location - Longitud
  /*
  {
    id: 'centroid_longitude',
    accessor: 'centroid_longitude',
    header: 'pages.operations.columns.centroid_longitude',
    enableSorting: false,
    enableFilter: false,
    filterType: 'text',
    filterOptions: filterCoordinateOptions,
    cell: ({ getValue, row }) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <DeviceOperationsCoordinatesCell info={{ getValue, row } as any} coordinateType="longitude" />
    ),
  },
  */
  {
    id: 'startTimestamp',
    accessor: 'startTimestamp',
    header: 'pages.operations.columns.operationStartTime',
    enableSorting: true,
    enableFilter: false,
    cell: ({ getValue, row }) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <DeviceOperationsDateCell info={{ getValue, row } as any} field="startTimestamp" />
    ),
  },
  {
    id: 'endTimestamp',
    accessor: 'endTimestamp',
    header: 'pages.operations.columns.operationEndTime',
    enableSorting: true,
    enableFilter: false,
    cell: ({ getValue, row }) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <DeviceOperationsDateCell info={{ getValue, row } as any} field="endTimestamp" />
    ),
  },
  {
    id: 'tz',
    accessor: 'tz',
    header: 'pages.operations.columns.timezone',
    enableSorting: false,
    enableFilter: false,
    cell: ({ getValue, row }) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <DeviceOperationsTimezoneCell info={{ getValue, row } as any} />
    ),
  },
  {
    id: 'durationMinutes',
    accessor: 'durationMinutes',
    header: 'pages.operations.columns.operationDuration',
    enableSorting: true,
    enableFilter: false,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cell: ({ getValue, row }) => <DeviceOperationsDurationCell info={{ getValue, row } as any} />,
  },
];
